import { generateAutomationName } from "app/pages/benchmark-tracker/helpers/helpers";

import type { ComponentSchema, MetricMappingSchema } from "../Tab/types";

import { StyledMetricWrapper } from "./styles";

type MetricViewEntity = {
    className?: string;
    onOpenModal?: ComponentSchema["onOpenModal"];
    setMetricOptions?: ComponentSchema["setMetricOptions"];
};

const Metric = ({
    Component,
    name,
    format,
    title,
    tooltip,
    secondaryTooltip,
    className,
    onOpenModal,
    setMetricOptions,
}: MetricViewEntity & MetricMappingSchema) => {
    return (
        <StyledMetricWrapper
            data-automation={generateAutomationName("report", ["metric", "wrapper", name as unknown as string])}
            className={className}
        >
            <Component
                name={name}
                title={title}
                format={format}
                tooltip={tooltip}
                secondaryTooltip={secondaryTooltip}
                onOpenModal={onOpenModal}
                setMetricOptions={setMetricOptions}
            />
        </StyledMetricWrapper>
    );
};

export default Metric;
